import jQuery from 'jquery'
import 'slick-carousel';

(function($) {
    $(function() {
        /**
         * Enforce a 1 / 1.5 aspect ration for all images
         */
        const $slider =$('.set-gallery.slider');
        function calcMaxHeight() {
            const width = $slider.width();
            const height = width / 16 * 9;
            $('img', $slider).each(function () {
                $(this).css('max-height', `${height}px`)
            });
            $slider.height(height)
        }
        calcMaxHeight();
        window.addEventListener('resize', calcMaxHeight);
        // Gallery
        $slider.slick({
            autoplay: false,
            pauseOnHover: false,
            dots: true,
            fade: true,
            centerMode: true,
        });
    });
})(jQuery);
